import React, { ReactNode } from "react";
import Text from "../Text";
import styles from "./BootCapacityTextBox.module.scss";
interface BootCapacityTextBoxProps {
  firstText: ReactNode;
  secondText?: ReactNode;
  className?: string;
}

export default function BootCapacityTextBox({
  firstText,
  secondText,
  className,
}: BootCapacityTextBoxProps) {
  return (
    <div className={`${styles.container} ${className}`}>
      <span className={styles.firstText}>{firstText}</span>
      {secondText && <span className={styles.secondText}>{secondText}</span>}
    </div>
  );
}
